import Main from "./Main.js";
import Scene from "./Scene.js";
export default class Wiframe {

	constructor(hs, parms, callback) {
		this.hs = hs;
		this.parms = parms;
		this.callback = callback;
		this.checkH = 0;
		console.log(hs)
	}

	init() {

		Main.debugTrace("Hotspot Wiframe: " + this.hs.name);
		// apre il layer con l'iframe
		let mc = jQuery("#template-trix-iframe").clone();
		mc.attr("id", "ifrax" + Wiframe.ENUM++);
		jQuery(".js-trix1010").append(mc);
		jQuery(".js-close-frame", mc).on("click", jQuery.proxy(this.closeFrame, this));
		this.mc = mc;
		this.dispatch({
			type: Main.HS_EVENT_HIDE_INTERFACE
		});

		/*let track = new Object();
		track.action = "clicked-hotspot";
		track.hotspot = this.hs.kind
		track.testo_it = this.hs.testo_it
		//console.log(this.hs)
		Main.tracking(track);*/
		//Main.setUrl(Scene.getCurrentScene().name, this.hs.Uid, null)
		this.createIFrame();

	}

	closeFrame(e) {
		jQuery(window).off("resize.ifr");
		this.iframe.remove();
		this.mc.remove();
		this.dispatch({
			type: Main.HS_EVENT_SHOW_INTERFACE
		});
		Main.setUrl(Scene.getCurrentScene().name, null, null);
	}

	dispatch(e) {
		this.callback.call(null, e);
	}

	createIFrame(e) {
		this.checkH = 0;
		let link = this.hs.InfoJson.iframe_url;
		if (link == "") {
			this.mc.remove();
			Main.alert("ATTENZIONE!", "Questo hotspot '" + this.hs.name + "' è di tipo 'iframe' ma nei fogli di google è stato ancora gestito.")
		} else {
			let iframe = jQuery("<iframe class='MC_Frame3D trix-iframe-dim'></iframe");
			iframe.attr("id", "ifrm" + Wiframe.ENUM++);
			iframe.addClass("to-remove");
			jQuery(".to-remove", jQuery(".js-trix-content")).remove();
			jQuery(".js-trix-content", this.mc).append(iframe);

			iframe.attr("src", link);
			this.iframe = iframe;

			if (link.toLowerCase().indexOf(Main.lbl("patchCfgUsIndexOf").toLowerCase()) >= 0) {
				jQuery(window).on("resize.ifr", jQuery.proxy(this.precheckHtocheck, this));
				//this.idres = setTimeout(jQuery.proxy(this.fitFrame,this),100);
				this.precheckHtocheck();
			}

		}
	}
	precheckHtocheck() {
		this.checkH = 0
		clearTimeout(this.idres);
		this.idres = setTimeout(jQuery.proxy(this.checkHtocheck, this), 100)
	}

	checkHtocheck() {
		this.fitFrame();
		clearTimeout(this.idcheck);
		if (this.checkH < 3) {
			//console.log("CHECK")
			this.checkH++;
			this.idcheck = setTimeout(jQuery.proxy(this.checkHtocheck, this), 200);
		}

	}


	fitFrame() {
		let lCondExit = false;
		let safe = 0;
		let w = 90;
		let clip = jQuery(".js-trix-content", this.mc);
		//console.log(clip.length)

		while (!lCondExit) {
			clip.css("width", w + "%");
			//console.log(clip.height()+ " " + (jQuery(".js-trix1010").height()-20))
			if (clip.height() > jQuery(".js-trix1010").height() - 20) {
				w--;
			} else {
				lCondExit = true;
			}
			safe++;
			if (safe == 50) {
				lCondExit = true;
			}
		}

	}
}
Wiframe.ENUM = 0;